import React from 'react';
import Footer from '../Footer';
import PricingHeader from '../PricingHeader';
import Pricing from '../Pricing';

const PricingPage = () => (
  <>
    <PricingHeader />
    <Pricing />
    <Footer />
  </>
);

export default PricingPage;
